import ApiLogin from './api-login';
import ApiOss from './api-oss';
import ApiUser from './api-user';
export default {
  ApiLogin,
  ApiOss,
  ApiUser
};
